module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYmY3MWY0NThmOWFhY2I1OWE3YzA1NDc4MzFlY2MwZDkucG5nIjs="